"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Tab = void 0;
var react_1 = __importStar(require("react"));
var tabs_1 = require("@reach/tabs");
var classnames_1 = __importDefault(require("classnames"));
var draft_badge_1 = require("@kaizen/draft-badge");
var Tab_module_scss_1 = __importDefault(require("./Tab.module.scss"));
/**
 * A tab button
 */
var Tab = function (props) {
    var isSelected = props.isSelected, badge = props.badge, disabled = props.disabled, children = props.children;
    var _a = (0, react_1.useState)(false), isHovered = _a[0], setIsHovered = _a[1];
    var _b = (0, react_1.useState)(false), isFocused = _b[0], setIsFocused = _b[1];
    var showActiveBadge = isSelected || isHovered || isFocused;
    var onFocus = function (event) {
        var _a;
        setIsFocused(true);
        (_a = props.onFocus) === null || _a === void 0 ? void 0 : _a.call(props, event);
    };
    var onBlur = function (event) {
        var _a;
        setIsFocused(false);
        (_a = props.onBlur) === null || _a === void 0 ? void 0 : _a.call(props, event);
    };
    return (react_1["default"].createElement(tabs_1.Tab, { disabled: disabled, className: (0, classnames_1["default"])(Tab_module_scss_1["default"].tab, isSelected && Tab_module_scss_1["default"].selected), onFocus: onFocus, onBlur: onBlur, onMouseEnter: function () { return setIsHovered(true); }, onMouseLeave: function () { return setIsHovered(false); } },
        children,
        badge && (react_1["default"].createElement("span", { className: Tab_module_scss_1["default"].badge },
            react_1["default"].createElement(draft_badge_1.Badge, { variant: showActiveBadge ? "active" : "default" }, badge)))));
};
exports.Tab = Tab;
//# sourceMappingURL=Tab.js.map